import script from "./PaymentMethod.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethod.vue?vue&type=script&setup=true&lang=js"

import "./PaymentMethod.vue?vue&type=style&index=0&id=54ec8098&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54ec8098"]])

export default __exports__